import React from 'react';
import {
  Card,
  Table,
} from "antd";
import { useOrderRiderHistory } from '../../../requests/order';
import { useParams } from 'react-router-dom';

import moment from "moment";

const OrderRiderSearchHistory = () => {

  const { id } = useParams();
  const { data: list } = useOrderRiderHistory(id);


  // ===================
  const columns = [
    {
      title: 'Date Time',
      dataIndex: '_date',
      key: '_date',
      render: _date => (
        // like 10/20 10:20:30 PM 
        <span style={{ fontSize: 12 }}>{moment(_date).format("MM-DD hh:mm:ss A")}</span>
      )
    },
    {
      title: 'Rider',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    }
  ];


  return (
    <Card title="Rider Finding history">
      <Table
        columns={columns}
        dataSource={list}
        pagination={false}

      />
    </Card>
  )
}

export default OrderRiderSearchHistory